module.exports = __webpack_public_path__ + "img/grass.fc876587.svg";